window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Main ================*/

/* ==========================================================================
   #MMENU (plugin)
   ========================================================================== */
   
/* 
 * Slide-out mobile menu with sub-menu support.
 * http://mmenu.frebsite.nl
 */
 
/* 
 * Main Menu navigation.
 */

$(document).ready(function() {
	$(".site-nav").mmenu({
	    hooks: {
			'initPanel:before': function( $panel ) {
				$panel.find('.megamenu')
				.each(function() {
					$(this)
					.wrapInner('<ul />')
					.children('ul')
					.unwrap();
				});
				$panel.find('.megamenu__block')
				.each(function() {
					$(this)
					.wrap('<li />')
					.children('ul, div')
					.unwrap()
				});
			}
		},
		// Options
		navbar: {
			title: false
		},
		navbars: {
			"position": "top",
			"content": [
				"searchfield"
			]
		},
		searchfield: {
			add: true,
			search: false
   		}
	},
	{
		// Config
		clone: true,
		offCanvas: {
			pageSelector: "#page"
		},
		classNames: {
			selected: "active",
			fixedElements: {
				fixed: "mm-fixed",
				sticky: "mm-sticky"
            }
		},
		searchfield: {
			form: {
				method: "get",
				action: "/search",
				role: "search"
			},
			input: {
				name: "q"
			},
			submit: true
		},
	});
	
	var API = $(".site-nav").data("mmenu");
	var $icon = $(".mmenu-toggle");
      
	$icon.on("click", function() {
		API.open();
	});

	API.bind( "open:finish", function() {
		setTimeout(function() {
			$icon.addClass( "is-active" );
		}, 100);
	});
	
	API.bind( "close:finish", function() {
		setTimeout(function() {
			$icon.removeClass( "is-active" );
		}, 100);
	});
	
});

/* 
 * Filter/categories navigation.
 */

$(document).ready(function() {
	$(".filters").mmenu({
		// Options
		navbar: {
			title: "Filters"
		}
	}, {
		// Configuration
		clone: true,
		offCanvas: {
			pageSelector: ".page"
		},
		classNames: {
			selected: "active"
		}
	});
	
	var API = $(".filters").data("mmenu");
	var $icon = $(".filter-toggle--mobile");
      
	$icon.on("click", function() {
		API.open();
	});
});


/* 
 * Toggle for desktop filters when MMENU isn't used. Basically just shows/hides
 * left-side column when triggered.
 */

$(".filter-toggle--desktop").click(function(){
	$(this).toggleClass("active");
	$(".grid").toggleClass("show-filters");
});

// Check if a filter is selected and preopen filters nav
if ($('.filters__link--active').length) {
    $(".filter-toggle--desktop").toggleClass("active");
	$(".grid").toggleClass("show-filters");
}


/* 
 * Allow increase and decrease of quantity triggers
 * 
 */
if ($('.qty__down').length || $('.qty__up').length) {
    // Decrease quantity
    $('.qty__down').on('click', function(){
        var quantityBox = $(this).parent().children('input');
        if (parseInt(quantityBox.val()) > 1) {
            quantityBox.val(parseInt(quantityBox.val()) - 1);
        }
        return false;
    });
    
    // Increase quantity
    $('.qty__up').on('click', function(){
        var quantityBox = $(this).parent().children('input');
        quantityBox.val(parseInt(quantityBox.val()) + 1);
        return false;
    });
}





/* ==========================================================================
   #SLICK (plugin)
   ========================================================================== */
 
/* 
 * Create responsive slideshows.
 * http://kenwheeler.github.io/slick
 */
 
$(document).ready(function(){
	$('.slick').slick({
		arrows: false,
		dots: true,
		infinite: false
	});
});





/* ==========================================================================
   #Simple Overlays
   ========================================================================== */
   
$(".overlay-link").click(function() {
	target = "#overlay-"+$(this).data("overlay");
	$(".overlay").hide();
	$(target).show();
	$( "body" ).css( "overflow" , "hidden" ); //disable the scroll
});

$(".overlay__close").click(function() {
	$(".overlay").hide();
	$( "body" ).css( "overflow" , "auto" );  //enables the scroll back
});





/* ==========================================================================
   #Simple Accordion
   ========================================================================== */

$('.accordion').find('.accordion__title').click(function(){
	$(this).toggleClass('open');
	$(this).next().slideToggle('fast');
});





/* ==========================================================================
   #SVG4EVERYBODY (polyfill)
   ========================================================================== */

/* 
 * IE9+ support for SVG sprites.
 * https://github.com/jonathantneal/svg4everybody
 */
 
$(function(){
	svg4everybody();
});





/* ==========================================================================
   #STICKYFILL (polyfill)
   ========================================================================== */

/* 
 * IE9+ support for `position: sticky;`.
 * https://github.com/wilddeer/stickyfill
 */
 
$(function(){ 
	var elements = document.querySelectorAll('.sticky');
	Stickyfill.add(elements);
});





/* ==========================================================================
   #CUSTOM JS SNIPPETS
   ========================================================================== */

/* 
 * Product options table.
 *
 * On clicking a table `tr` the relevant radio button becomes selected.
 */
 
$(document).ready(function() {
  $('.product__options tr').click(function(event) {
    if (event.target.type !== 'radio') {
      $(':radio', this).trigger('click');
    }
  });
});

//
//
//
//
//
//
// EVERYTHING BELOW THIS LINE IS TEMPORARY AND FOR DEMO ONLY
//
//
// Basic script just to demonstrate mini-cart appearing when a product is added to the basket or when the basket icon is clicked.
/*
$(".h-product .btn, .user-nav__link--basket").click(function(e){
	e.preventDefault();
    $(".mini-cart").toggleClass('hide');
});
*/
$(".mini-cart__close").click(function(e){
	e.preventDefault();
    $(".mini-cart").toggleClass('hide');
});
// Basic script just to demonstrate mini-cart appearing when a product is added to the basket or when the basket icon is clicked.
$(".filters__link").click(function(e){
    $(this).toggleClass("filters__link--active");
});


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
     * @namespace product
 */

theme.Product = (function() {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }
        
        // Handle timer and shipping date display
        if ($('[delivery-time-left]').length && $('[delivery-next-available]').length) {
            var loading = true;
            var querystring = '';
            var startDate = {};

            // Retrieve the disabled dates from management app
            $.get(systemSettings.managementUrl + '/shipping-start-date.json'+querystring, {}).done(function(response){
                startDate = moment(response.shipping_start_date, 'YYYY-MM-DD');
                loading = false;
                
                var orderBy = moment(startDate);
                orderBy.subtract(1, 'day');
                orderBy = moment(orderBy.format('YYYY-MM-DD')+' 05:00:00');

                // Set the nearest delivery date
                $('[delivery-next-available]').html(startDate.format('ddd Do MMM'));
                
                setInterval(function() { makeTimer(new Date(orderBy.toDate()), $('[delivery-time-left]')); }, 1000);
            });
        }
    }

    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function(evt) {
            var variant = evt.variant;

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true);
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
            }
        },

        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function(evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            $(selectors.productPrice, this.$container)
                .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function(evt) {
            var variant = evt.variant;
            var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

            this.$featuredImage.attr('src', sizedImgUrl);
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function() {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Shipping Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 * Handle the forcing of a defined shipping date and attach it to cart
 *
 * @namespace shipping
 */

    /*
     * shipping
     */
    var shipping = function(options){
     
        /*
         * Variables accessible
         * in the class
         */
        var vars = {
            shippingCost : 0, // The original shipping cost on page load
            startDate : false, // First available shipping date
            datefield : false, // Element object
            deliveryDate : false, // Set delivery date
            endDays: 365, // Set how many days in the future we can book for
            disabledDates : false, // the disabled dates
            productIds: [] // the products to check available dates on
        };
        
        this.disabledDates = false;
        
        /*
         * State variables
         * 
         */
        var loading = false;
     
        /*
         * Can access this.method
         * inside other methods using
         * root.method()
         */
        var root = this;
     
        /*
         * Constructor
         */
        this.construct = function(options){
            $.extend(vars , options);
        };
     
     
        /*
         * Public methods
         * Can be called outside class
         */
         
        /*
         * function addError
         * Add an error notice so user knows to define their shipping
         *
         * @return void
         */
        this.addError = function(){
            $('p.shipping').remove();
            vars.datefield.addClass('error').before('<p class="error shipping">Please select a delivery date before continuing.</p>');
        };
        
        /*
         * function addShippingProduct
         * Add a shipping product by variant ID to the cart AND dom
         *
         * @param int
         * @return void
         */
        this.addShippingProduct = function(variant_id){
            if (!$('#variant_id_'+variant_id).length) {
                var saturdayShippingProduct = {
                    quantity: 1,
                    id: variant_id
                };
                
                // Add the saturday shipping product
                $.post('/cart/add.js', saturdayShippingProduct, function(){
                    window.location.replace('/cart');
                },"json");
            }
        };
        
        /*
         * function removeShippingProduct
         * Remove a shipping product by variant ID from the cart AND dom
         *
         * @param int
         * @return void
         */
        this.removeShippingProduct = function(variant_id){
            if ($('#variant_id_'+variant_id).length) {
                var saturdayShippingProduct = {updates: {}};
                saturdayShippingProduct.updates[variant_id] = 0;
                        
                // Remove the saturday shipping product
                $.post('/cart/update.js', saturdayShippingProduct, function(){
                    window.location.replace('/cart');
                },"json");
            }
        };
        
        /*
         * function dateFieldUpdate
         * After the selection of a new date execute this action
         *
         * @return void
         */
        this.dateFieldUpdate = function(field){
            var dayOfWeek = vars.datefield.datepicker('getDate').getDay();

            // Add the shipping date to the cart
            $.post('/cart/update.js', {note: field.val()}, function(response){
                // If saturday
                // NOTE - TEMPORARY REMOVAL OF SATURDAY SHIPPING CHARGE
                if (dayOfWeek == 6 && 1==2) {
                    // Add the correct surcharge product dependent on current cart total
                    if (vars.shippingCost != 'FREE') {
                        root.removeShippingProduct(14545816682539);
                        root.addShippingProduct(17068385599531);
                    } else {
                        root.removeShippingProduct(17068385599531);
                        root.addShippingProduct(14545816682539);
                    }
                // Check if saturday shipping was previously in the cart
                } else {
                    root.removeShippingProduct(17068385599531);
                    root.removeShippingProduct(14545816682539);
                }
            },"json");
        }
        
        /*
         * function dateIsValid
         * check if the current date is valid with shipping options
         *
         * @return bool
         */
        this.dateIsValid = function(){
            loading = true;

            // Retrieve the disabled dates from management app
            return $.get(systemSettings.managementUrl + '/valid-shipping-date.json', {"date" : vars.datefield.val()}).then(function(response){
                loading = false;
                if (response.is_valid) {
                    return response.is_valid;
                }
                return false;
            });
        }
        
        /*
         * function resetDateField
         * reset the date field back to the closest available date
         *
         * @return void
         */
        this.resetDateField = function(){
            vars.datefield.val('').focus();
            root.addError();
        }
         
         /*
         * function setup
         * Setup the class and associated elements like the datepicker filters
         *
         * @return void
         */
        this.setup = function(){
            vars.shippingCost = $('[shipping-cost]').html();
            
            // Show correct shipping cost if saturday shipping
            if($('#variant_id_14545816682539').length) {
                var newShippingPrice = $('#variant_id_14545816682539').find('.basket__price strong').html();
                $('[shipping-cost]').html(newShippingPrice);
            }
            
            // Retrieve remote data
            getStartDate(function(){
                getDisabledDates(function(){
                    // Setup the datepicker based on available dates
                    vars.datefield.datepicker({
                        // Format
                        format: 'dd/mm/yyyy',
                        
                        // Set the start date as the start date
                        startDate: moment().toDate(),
                        
                        // Set the longest in the future we can choose as 1 year
                        endDate: moment().add(vars.endDays, 'days').toDate(),
                        
                        // Set the start date
                        date: vars.startDate.toDate(),
                        
                        // Pick the first date automatically
                        autoPick: true,
                        
                        // Add the filter for the disabled days
                        filter: function(date){
                            if ($.inArray(mysqlDateFormat(date), vars.disabledDates) !== -1) {
                                return false;
                            }
                        }
                    });
                    
                    // Set the date if required
                    if ($('#cart_note').length && $('#cart_note').val() != '') {
                        var splitDate = $('#cart_note').val().split('/');
                        var date = new Date(splitDate[2]+"-"+splitDate[1]+"-"+splitDate[0]);
                        if ($.inArray(mysqlDateFormat(date), vars.disabledDates) == -1) {
                            vars.datefield.datepicker("setDate", date);
                        }
                    }
                    
                    // On change of datepicker field hit this callback
                    vars.datefield.on('change', function(){
                        root.dateFieldUpdate($(this));
                    });
                });
            });
        }
            
         /*
         * function validate
         * Check current set shipping date is valid
         *
         * @return bool
         */
        this.validate = function(){
            // First check we have a date
            if (vars.datefield.val() == '') {
                root.addError();
                return false;
            }

            // Re-check this is a valid shipping date
            return root.dateIsValid().then(function(isValid){
                if (!isValid) {
                    root.resetDateField();
                    return true;
                } else {
                    return true;
                }
            });
        };
     
     
     
        /*
         * Private function getDisabledDates
         * Retrieve the disabled shipping dates from the management system
         * This will be the dates leading up to the next available date as well as any
         * disabled dates for the following 12 months, datepicker should be disabled post 12 months
         *
         * @return array
         */
        var getDisabledDates = function(callback) {
            loading = true;
            
            var querystring = '';
            if (vars.productIds != '') {
                querystring += '?product_ids='+vars.productIds;
            }

            // Retrieve the disabled dates from management app
            $.get(systemSettings.managementUrl + '/disabled-shipping-dates.json'+querystring, {}).done(function(response){
                vars.disabledDates = response.disabled_shipping_dates;
                loading = false;
                callback();
            });
        };
        
        /*
         * Private function getStartDate
         * Retrieve the dfirst available shipping date
         *
         * @return array
         */
        var getStartDate = function(callback) {
            loading = true;
            
            var querystring = '';
            if (vars.productIds != '') {
                querystring += '?product_ids='+vars.productIds;
            }

            // Retrieve the disabled dates from management app
            $.get(systemSettings.managementUrl + '/shipping-start-date.json'+querystring, {}).done(function(response){
                vars.startDate = moment(response.shipping_start_date, 'YYYY-MM-DD');
                loading = false;
                callback();
            });
        };
        
        /*
         * Private function mysqlDateFormat
         * Return as mysql formatted date string Y-m-d
         *
         * @return array
         */
        var mysqlDateFormat = function(date) {
            return date.getFullYear() + '-' + twoDigits(1+date.getMonth()) + "-" + twoDigits(date.getDate());
        }
        
        /**
         * You first need to create a formatting function to pad numbers to two digits…
         **/
        var twoDigits = function(d) {
            if(0 <= d && d < 10) return "0" + d.toString();
            if(-10 < d && d < 0) return "-0" + (-1*d).toString();
            return d.toString();
        }
     
     
        /*
         * Pass options when class instantiated
         */
        this.construct(options);
     
    };
/**
 * Postcode Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 * Handle the management of postcodes in relation to delivery address
 *
 * @namespace postcode
 */

    /*
     * shipping
     */
    var postcode = function(options){
     
        /*
         * Variables accessible
         * in the class
         */
        var vars = {
            postcodefield : false, // Element object
            
        };
        
        /*
         * State variables
         * 
         */
        var loading = false;
     
        /*
         * Can access this.method
         * inside other methods using
         * root.method()
         */
        var root = this;
     
        /*
         * Constructor
         */
        this.construct = function(options){
            $.extend(vars , options);
        };
     
     
        /*
         * Public methods
         * Can be called outside class
         */
         
         /*
         * function hideError
         * Hide the error
         *
         * @return void
        */
        this.hideError = function(){
            $(vars.postcodefield).removeClass('error');
            $('.error.postcode').remove();
            $(vars.postcodefield).data('valid', true);
        }
        
         /*
         * function setup
         * Setup the class and associated elements like the datepicker filters
         *
         * @return void
         */
        this.setup = function(){
            var that = this;
            $(vars.postcodefield).on('keyup', function(){
                that.validate(function(){});
            });
        }
        
        /*
         * function showError
         * Show an error
         *
         * @return void
        */
        this.showError = function(){
            $(vars.postcodefield).addClass('error').after('<p class="postcode error">Sorry, but we do not currently ship to this postcode.</p>').data('valid', false);
        }
            
        /*
         * function validate
         * Check current set postcode is valid
         *
         * @return bool
        */
        this.validate = function(callback){
            loading = true;
            this.hideError();
            
            var querystring = '';
            querystring += '?postcode='+$(vars.postcodefield).val();
            
            var that = this;

            // Retrieve the disabled dates from management app
            return $.get(systemSettings.managementUrl + '/valid-postcode.json'+querystring, {}).done(function(response){
                // Set the valid flag
                var valid = true;

                if (!response.success) {
                    valid = true;
                } else if (response.is_valid) {
                    valid = response.is_valid;
                } else if (!response.is_valid) {
                    valid = response.is_valid;
                }
                
                loading = false;
                callback();

                if (!valid) {
                    that.showError();
                }
                
                return valid;
            });
        };
     
        /*
         * Pass options when class instantiated
         */
        this.construct(options);
     
    };
/**
 * Checkout/Cart Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 * Handle the forcing of validation and other checkout flow scripting
 *
 * @namespace cart
 */

theme.cart = (function() {
    /*
     * USAGE
     */
     
    /*
     * Shipping class expects a datepicker object to manipulate
     */
    var datefield = $(".datepicker");
    var postcodefield = $('#CartCheckoutPostcode');
    var productIds = $("#product_ids").val();
    var postcodeClass = new postcode({'postcodefield' : postcodefield});
    var shippingClass = new shipping({'datefield' : datefield, 'productIds' : productIds});
    var datefieldInteraction = false; // Set if the user has interacted with the datefield
    var shippingValidated = true;
    
    // Set up the datepicker
    shippingClass.setup();
    postcodeClass.setup();
    
    /*
     * Catch focus of datefield to set the interaction
     */
    $(datefield).on('focus', function(){
        datefieldInteraction = true;
    });
    
    /*
     * Catch validation of input
     */
    $('.basket-form').on('submit', function(e){
        if (!shippingValidated) {
            e.preventDefault();
        }
        
        var valid = true;
        var action = $("input[type=submit]:focus");
        var self = $(this);

        // If we are just updating the cart, bypass validation
        if ($(action).hasClass('novalidate')) {
            return valid;
        }
        
        if (!validateCart()) {
            valid = false;
        }
        
        // Check postcode validation and append to action as necessary
        if ($(postcodefield).val() != '' && !$(postcodefield).data('valid')) {
            alert('Sorry, we do not deliver to this postcode yet.');
            valid = false;
        } else {
            amendQuerystring();
        }
        
        if (valid && !datefieldInteraction) {
            confirm('Your order will be delivered on ' + $(datefield).val() + ', is this OK?');
        }
            
        return valid;
    });
    
    /*
     * function amendQuerystring
     * Append the postcode to the querystring args to pass through
     *
     * @return void
    */
    function amendQuerystring()
    {
        var postcode = $(postcodefield).val();
        var submitUrl = '/cart'; // Default url for submission
        
        // Append the new value
        submitUrl += '?checkout[shipping_address][zip]='+postcode;
        
        // Update the form's url
        $('.basket-form').attr('action', submitUrl);
    }
    
    /*
     * Timed validation check to re-test shipping every 15 minutes
     */
    window.setInterval(function(){shippingValidate()}, 900000);
    function shippingValidate()
    {
        if (datefield.val() != '') {
            window.location.reload();
        }
    }
    
    /*
     * function validateCart
     *
     * Validate if the user can continue to checkout
     */
    function validateCart()
    {
        // Reset
        $('p.validation').remove();
        
        // Check terms and conditionas have been accepted
        if (!$('input[name="terms"]').is(':checked')) {
            $('input[name="terms"]').parent().before('<p class="error validation">You must agree to the terms and conditions.</p>');
            return false;
        }
        // Check postcode for value
        if ($(postcodefield).val() == '') {
            $('input[name="terms"]').parent().before('<p class="error validation">You must enter a valid postcode.</p>');
            $(postcodefield).focus();
            $('html, body').stop().animate({ scrollTop: ($(postcodefield).offset().top - 80) }, 300);
            return false;
        }
        
        return true;
    }
    
    /*
    * EVENTS
    */
    $('[limit-input]').on('keyup', function(){
        var total = parseInt($(this).val().length);
        var limit = parseInt($(this).data('limit'));
        var currentString = $(this).val();

        if (total > limit) {
            var newString = currentString.substr(0, limit);
            $(this).val(newString);
        }
        
    });
    
    $('[force-upsell]').on('click', function(){
        $('html,body').animate({
            scrollTop: ($("#cart-upsell").offset().top - 100)
        });
        return false;
    });
})();
function makeTimer(endTime, element) {

//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");
	endTime = (Date.parse(endTime) / 1000);

	var now = new Date();
	now = (Date.parse(now) / 1000);

	var timeLeft = endTime - now;

	var days = Math.floor(timeLeft / 86400); 
	var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
	var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
	var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

	if (hours < "10") { hours = "0" + hours; }
	if (minutes < "10") { minutes = "0" + minutes; }
	if (seconds < "10") { seconds = "0" + seconds; }

	$(element).find("#days").html(days + "<span> days</span>");
	$(element).find("#hours").html(hours + "<span> hours</span>");
	$(element).find("#minutes").html(minutes + "<span> minutes</span>");
	$(element).find("#seconds").html(seconds + "<span> seconds</span>");		

}

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
